<template>
  <div class="page flex-col">
    <HeadVue></HeadVue>
    <div class="group_1 flex-col justify-between">

      <div class="box_2 flex-col">
        <div class="box_3 flex-row justify-between">
          <span class="text_5">垂直大模型</span>
        </div>
        <div class="box_4 flex-row justify-between">
          <img class="image_3" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
          <div class="image-text_1 flex-row justify-between">
            <span class="text-group_1">用低代码平台助工业企业填补数字化最后一公里沟壑</span>
            <img class="image_4" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
          </div>
        </div>
        <div class="box_5 flex-row">
          <div class="group_2 flex-col justify-between">
            <div class="text-group_2 flex-col justify-between">
              <span class="text_6">提高生产运营智能化水平</span>
              <span class="text_7">推动跨企业集成互联与智能运营建设智能现场</span>
            </div>
            <div class="text-group_3 flex-col justify-between">
              <span class="text_8">提高用户服务敏捷化水平</span>
              <span class="paragraph_1">
                ●建设数字营销网络建设敏捷响应服务体系
                <br />
                ●探索平台化、集成化、场景化增值服务
              </span>
            </div>
            <div class="text-group_4 flex-col justify-between">
              <span class="text_9">提高生产运营智能化水平</span>
              <span class="paragraph_2">
                ●建设产业链数字化生态协同平台
                <br />
                ●探索跨企业、跨产业、跨界合作新模式
              </span>
            </div>
          </div>
          <div class="text-wrapper_2 flex-col justify-between">
            <span class="paragraph_3">
              开发效率
              <br />
              提升3-10倍
            </span>
            <span class="paragraph_4">
              开发工作
              <br />
              提高10-50%
            </span>
            <span class="paragraph_5">
              人力成本
              <br />
              下降10-30%
            </span>
          </div>
          <div class="image-wrapper_1 flex-col justify-between">
            <img class="image_5" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG98238601c2c6c7dee24c37badf0b482e.png" />
            <img class="image_6" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG98238601c2c6c7dee24c37badf0b482e.png" />
            <img class="image_7" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNGb51cc63b8bd2778eb2b60a9502ad57f8.png" />
          </div>

        </div>
        <div class="box_6 flex-row justify-between">
          <img class="image_8" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
          <div class="image-text_2 flex-row justify-between">
            <span class="text-group_5">合作伙伴</span>
            <img class="image_9" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
          </div>
        </div>
        <div style="margin: auto">
          <div class="box_7 flex-row justify-between" style="margin-bottom: 20px">
            <div class="group_3 flex-row">
              <div class="box_9 flex-col">
              </div>
            </div>
            <div class="group_9 flex-col">
              <div class="box_16 flex-col">
              </div>
            </div>
            <div class="group_11 flex-col">
              <div class="block_1 flex-col">
              </div>
            </div>
            <div class="group_12 flex-row">
              <img class="image_10" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNGc6562d46ce5cce8f9491e408e910ae79.png" />
              <img class="image_11" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG0a04a2e868eb59fc11cbebb3dc7d9640.png" />
              <div class="section_16 flex-col"></div>
            </div>
            <div class="group_13 flex-col">
              <div class="section_17 flex-col">
                <div class="box_18 flex-col"></div>
              </div>
            </div>
          </div>
          <div class="box_19 flex-row justify-between" style="margin-bottom: 20px">
            <div class="group_14 flex-col">
              <div class="block_2 flex-col">
                <div class="box_20 flex-col"></div>
              </div>
            </div>
            <div class="group_15 flex-col">
              <div class="group_16 flex-col">
                <div class="box_21 flex-col"></div>
              </div>
            </div>
            <div class="group_17 flex-row">
              <img class="image_12" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNGde5c5b27b358f4b528d7cfbc315bd056.png" />
              <span class="text_10">湖北汽车工业学院</span>
              <div class="group_18 flex-col"></div>
            </div>
            <div class="group_19 flex-row justify-between">
              <img class="image_13" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG4fcae8a023595816263ee324a3eefa25.png" />
              <span class="text_11">湖北商贸学院</span>
              <div class="box_22 flex-col"></div>
            </div>
            <div class="group_20 flex-row justify-between">
              <img class="image_14" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNGb6434cbf9df901c4b011584133237528.png" />
              <span class="text_12">华中科技大学</span>
              <div class="group_21 flex-col"></div>
            </div>
          </div>
          <div class="box_23 flex-row justify-between" style="margin-bottom: 20px">
            <div class="box_24 flex-row">
              <img class="image_15" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG08451367dde096a2e697283c550bd280.png" />
              <span class="paragraph_6">
              中国科学院空天
              <br />
              信息穿心研究院
            </span>
              <div class="box_25 flex-col"></div>
            </div>
            <div class="box_26 flex-row">
              <img class="image_16" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG01e8279be4a353534c66e4fc0a81031c.png" />
              <span class="text_13">湖北科技职业学院</span>
              <div class="group_22 flex-col"></div>
            </div>
            <div class="box_27 flex-row">
              <img class="image_17" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG4e4c4b73b1160aef6035529f7156890e.png" />
              <span class="text_14">重庆西南大学</span>
              <div class="section_18 flex-col"></div>
            </div>
          </div>
        </div>


        <div class="box_34 flex-col"></div>
        <div class="box_35 flex-col"></div>
        <FooterVue style="margin-top: 102px"></FooterVue>
      </div>

      <div class="box_36 flex-col">
        <Carousel style="margin-top: 60px; height: 500px" :items="carouselItems"  :interval="3000" >
          <div class="banner-inner1 carousel-item" >
            <div>
              <h1 class="banner-inner-title iconfont">构建自进化工业智能体</h1>
              <p class="banner-inner-desc">全力打造会学习、能进化的工业 <span style="margin-left: 10px;margin-right: 10px">“智数”</span> 体系，领航工业产业超速前行！</p>
            </div>
            <div style="margin-left: 110px">
              <img :src="require('./assets/img/carouseImage/inner-left.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
          <div class="banner-inner2 carousel-item">
            <div style="margin-top: 35px">
              <h1 class="banner-inner-title">解锁工业新生密码</h1>
              <p class="banner-inner-desc">AI 赋能产业升级，激发全链条、全环节、全流程的精准洞察与智能感知新效能！</p>
            </div>
            <div style="margin-left: 35px;margin-bottom: 40px; margin-top: 35px">
              <img :src="require('./assets/img/carouseImage/inner-left2.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
          <div class="banner-inner3 carousel-item">
            <div>
              <h1 class="banner-inner-title">开启理想工业新征程</h1>
              <p class="banner-inner-desc">AI 无缝对接生产运营各领域，擘画未来企业崭新时代！</p>
            </div>
            <div style="margin-left: 216px">
              <img :src="require('./assets/img/carouseImage/inner-left3.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
        </Carousel>
        <div class="group_27 flex-row justify-between">
          <img class="image_23" referrerpolicy="no-referrer"
               src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
          <span class="text_39" style="margin-right: 35px; margin-left: 30px"> 塑造&nbsp;“1&nbsp;核&nbsp;+&nbsp;2&nbsp;翼&nbsp;+&nbsp;N&nbsp;点”&nbsp;的智慧工业生态体</span>
          <img class="image_24"  referrerpolicy="no-referrer"
               src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
<!--          <span class="text_39">-->
<!--            塑造&nbsp;“1&nbsp;核&nbsp;+&nbsp;2&nbsp;翼&nbsp;+&nbsp;N&nbsp;点”&nbsp;的智慧工业生态体-->
<!--          </span>-->
<!--          <div class="box_38 flex-col justify-center align-center">-->
<!--            <div class="group_28 flex-col"></div>-->
<!--          </div>-->
        </div>
        <span class="text_40">用智能科技改变世界，让AI触手可及</span>
        <div class="text_41">
          <span>明晟云</span>
          <div class="line"></div>
        </div>
        <div class="text_42">
          <span style="margin-left: 80px;">明晟工业数字化平台</span>
          <div class="line"></div>
        </div>
        <div class="group_29 flex-row">
          <div class="group_30 flex-col justify-between">
            <div class="text_43">
              <span>明晟研究院</span>
              <div class="line"></div>
            </div>

<!--            <div class="group_31 flex-col"></div>-->
          </div>
          <span class="text_44">大模型</span>
          <div class="group_32 flex-col">
            <div class="image-wrapper_5 flex-col">
              <img class="image_22" referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG0c5e18165d85e036857204790a77b18b.png" />
            </div>
          </div>
        </div>
        <div class="group_33 flex-row justify-between" style="margin-top: 95px">
          <img class="image_23" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
          <span class="text_45">工业企业数智化难题</span>
          <img class="image_24" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
        </div>
        <span class="text_46">终端需求快速迭代，开发资源不均衡问题困扰开发者和企业客户</span>
        <div class="text-wrapper_13 flex-row justify-between" style="margin-bottom: 30px;margin-top: 30px">
          <div style="display: flex;flex-direction: column">
            <span class="text_47">越来越复杂的应用场景</span>
            <span class="text_49">面对日益增长的多元化、多场景业务需求也在驱使制造企业不断部署新的资源</span>
          </div>
          <div style="display: flex;flex-direction: column">
            <span class="text_47">企业内外部协同重构</span>
            <span class="text_49">面对日益增长的多元化、多场景业务需求也在驱使制造企业不断部署新的资源</span>
          </div>
        </div>
        <div class="group_34 flex-row justify-between">
          <div class="block_3 flex-col">
            <span class="text_51">不断变化的市场需求</span>
            <span class="text_52">最终用户的需求在快速变化且存在不确定性，并随时发起的需求和响应反馈</span>
            <div class="text-group_7 flex-col justify-between">
              <span class="text_53">项目交付遇到各种问题</span>
              <span class="text_54">
                程序员抽象能力弱，对业务知识缺乏有效积累和传承、无法满足定制化需求，导致交付周期漫长
              </span>
            </div>
            <div class="text-group_8 flex-col justify-between">
              <span class="text_55">新技术不断涌现</span>
              <span class="text_56">开发人员面对技术的的推陈出新，缺少时间培训适应周期较长</span>
            </div>
          </div>
          <div class="block_4 flex-col">
            <div class="block_5 flex-col"></div>
          </div>
          <div class="text-wrapper_14 flex-col">
            <span class="text_57">线上/线下融合闭环</span>
            <span class="text_58">
              不同企业的传统业务与数字化路径不尽相同，而构建自我生态，在产业链上下游不同节点的企业也会有不同理解
            </span>
            <span class="text_59">合规、高效数字系统</span>
            <span class="text_60">
              随着全球疫情新常态、IT国产化趋势加剧，符合企业、国家、多区域安全标准和IT规范的要求，成为企业选择数字化服务时重要的指导要素
            </span>
            <span class="text_61">数据能力</span>
            <span class="text_62">
              对于数据的筛选、归类、详细刻画成为企业对数据应用的新开始，因此对数据的权属+触点满足+对应产品的“千人前面”应用，成为企业解读新“流量效应”的本质
            </span>
          </div>
        </div>
        <div class="group_35 flex-row justify-between">

          <div class="image-text_3 flex-row justify-between" style="margin-top: 50px">
            <img class="image_25" referrerpolicy="no-referrer"
                 style="margin-right: 20px"
                 src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <span class="text-group_9">利用垂直大模型实现知识资产和模型的结合</span>
            <img class="image_26" referrerpolicy="no-referrer"
                style="margin-left: 20px"
                 src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
          </div>
        </div>
<!--        <div class="group_36 flex-row justify-between">-->
<!--          <div class="box_39 flex-col"></div>-->
<!--          <span class="text_63">内容生成，降本</span>-->
<!--        </div>-->
        <div class="group_37 flex-row">
          <div class="block_6 flex-col">
            <!-- <div class="block_7 flex-col"></div> -->
          </div>
          <img class="image_27" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG5c92243ab9e35cab1892ad1e72ab1cda.png" />
          <div class="image-wrapper_6 flex-col justify-between">
            <img class="image_28" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNGe19c9cfa7e308191f265b4ba9750d8e3.png" />
            <img class="image_29" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNGe19c9cfa7e308191f265b4ba9750d8e3.png" />
            <img class="image_29" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNGe19c9cfa7e308191f265b4ba9750d8e3.png" />
          </div>
          <div class="text-wrapper_15 flex-col justify-between">
            <span class="text_63">内容生成，降本</span>
            <span class="text_64">数字员工，增效</span>
            <span class="text_65">辅助决策，提质</span>
          </div>
        </div>
        <div class="group_38 flex-col" style="margin-top: 113px">
          <div class="text-wrapper_16 flex-col"><span class="text_66">私有数据</span></div>
          <div class="box_40 flex-col">
            <span class="text_67">经营数据</span>
            <div class="box_41 flex-col">
              <div class="group_39 flex-col">
                <div class="box_42 flex-col"></div>
              </div>
            </div>
          </div>
          <div class="text-wrapper_17 flex-col"><span class="text_68">公有数据</span></div>
        </div>
        <div class="group_40 flex-col" ></div>
        <div class="group_41 flex-col"></div>
        <div class="group_42 flex-col justify-center align-center">
          <div class="block_8 flex-col"></div>
        </div>
        <div class="group_43 flex-col"></div>
        <div class="group_44 flex-col"></div>
        <div class="image-wrapper_7 flex-col">
          <img class="image_30" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG227bc0fe802e31d22bc3f395dd97ea1e.png" />
        </div>
        <div class="group_45 flex-col"></div>
        <div class="group_46 flex-col">
          <div class="box_43 flex-col"></div>
        </div>
        <div class="group_47 flex-col"></div>
        <div class="group_48 flex-col">
          <div class="image-wrapper_8 flex-col">
            <img class="image_31" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNGfc6f5d366ca3983d88fa6c58b4243ab6.png" />
          </div>
        </div>
        <div class="group_49 flex-col"></div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
import Carousel from "./component/Carousel/index.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    Carousel,
    HeadVue,
    FooterVue,
  },
  data() {
    return {
      carouselItems: [
        {
          image: 'https://picsum.photos/id/1018/800/400',
          title: '美丽的山脉',
          description: '壮观的自然风景'
        },
        {
          image: 'https://picsum.photos/id/1015/800/400',
          title: '河流与森林',
          description: '宁静的自然环境'
        },
        {
          image: 'https://picsum.photos/id/1019/800/400',
          title: '城市景观',
          description: '现代都市风光'
        }
      ],
      loopData0: [
        { lanhutext0: '公司简介', lanhutext1: '团队介绍' },
        { lanhutext0: '今日头条', lanhutext1: '西瓜视频' }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
